import { useQuery } from '@apollo/client';
import { GET_DRIVER_LEARNING_CENTER_FAQ_NODES_WITH_PAGINATION } from '../graphql/queries';
import { DriverLearningCenterFaqNode, DriverLearningCenterFaqPageResponse, FAQ_NODE_TYPE_CATEGORY } from '../graphql/types';

/**
 * 分类行分页列表（每页 10 条）。
 */
export const useLearningCenterFaqCategoryList = (
  pageNum: number,
  pageSize: number,
  keyword: string | null,
  isEnabled: boolean | null
) => {
  const { data, loading, refetch } = useQuery<{
    getDriverLearningCenterFaqNodesWithPagination: DriverLearningCenterFaqPageResponse;
  }>(GET_DRIVER_LEARNING_CENTER_FAQ_NODES_WITH_PAGINATION, {
    variables: {
      request: {
        pageNum,
        pageSize,
        nodeType: FAQ_NODE_TYPE_CATEGORY,
        keyword: keyword || null,
        isEnabled: isEnabled === null ? null : isEnabled,
      },
    },
    fetchPolicy: 'network-only',
  });

  const response = data?.getDriverLearningCenterFaqNodesWithPagination;

  return {
    categories: response?.content || [],
    total: response?.total || 0,
    loading,
    refetch,
  };
};

/**
 * 展开分类后按需加载其下问答（不单独分页，一次取完）。
 */
export const useLearningCenterFaqArticleList = (
  parentId: string | null,
  keyword: string | null,
  isEnabled: boolean | null,
  skip: boolean
) => {
  const { data, loading, refetch } = useQuery<{
    getDriverLearningCenterFaqNodesWithPagination: DriverLearningCenterFaqPageResponse;
  }>(GET_DRIVER_LEARNING_CENTER_FAQ_NODES_WITH_PAGINATION, {
    variables: {
      request: {
        pageNum: 1,
        pageSize: 1000,
        nodeType: 2,
        parentId,
        keyword: keyword || null,
        isEnabled: isEnabled === null ? null : isEnabled,
      },
    },
    fetchPolicy: 'network-only',
    skip: skip || !parentId,
  });

  const articles: DriverLearningCenterFaqNode[] =
    data?.getDriverLearningCenterFaqNodesWithPagination?.content || [];

  return {
    articles,
    loading,
    refetch,
  };
};
